export default __webpack_public_path__ + "static/media/BrainBreak cards25.b069fb01.png";